/**
 * Completa ítems guardados (zonas, points) contra su catálogo.
 *
 * El backend los devuelve con id y nombre nada más, pero los selectores de
 * `@paquery-team/lib-driver-detail` etiquetan cada tag con un campo propio del
 * catálogo (`fullName` para zonas, `detail` para points) y muestran
 * "Desconocido" si falta. Si el ítem no está en el catálogo — o éste todavía no
 * cargó — se arma la etiqueta con lo que haya.
 */
const hydrateCatalogItems = (saved, catalog, labelField) =>
  (saved ?? [])
    .filter(Boolean)
    .map(
      (item) =>
        (catalog ?? []).find((option) => option.id === item.id) ?? {
          ...item,
          [labelField]: item[labelField] ?? item.name ?? `#${item.id}`,
        },
    );

export default hydrateCatalogItems;
